import React from 'react'
import Header from './Header'
import Footer from './Footer'




function Layout(props) {

    const { children } = props

  return (
    <> 
      <Header />
        <main className='flex flex-col bg-white'>
            {children}
        </main>
      <Footer />
    </>
  )
}

export default Layout